import { KizenTypography } from 'app/typography';
import { TestFixture } from 'ts-components/filters/TestFixture';

const StyleGuidePage = () => {
  return (
    <div className="container">
      <KizenTypography type="hero" style={{ margin: '1em 0' }}>
        Filters v2
      </KizenTypography>
      <TestFixture />
    </div>
  );
};

export default StyleGuidePage;
